import getCMSObject from './getCMSObject';
var getTelescriptItem = function (key) {
    if (key === void 0) { key = 'missing'; }
    return getCMSObject("data.components.teleScripts.".concat(key, ".jsonBlock"));
};
export default getTelescriptItem;
